import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ViewBreakpointService } from '@common-module/app-services/view-breakpoint.service';
import { SensorName } from '@common-module/modelinterfaces/enums/sensor-name';
import { SensorLastValue } from '@common-module/modelinterfaces/sensor-last-value.model';
import { UnitAdditionalData } from '@common-module/modelinterfaces/unit-additional-data.model';
import { NgClass, AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SensorValuePipe } from '@common-module/pipes/sensor-value.pipe';

@Component({
    selector: 'app-address-card',
    templateUrl: './address-card.component.html',
    styleUrls: ['../carousel-card-styles.component.scss'],
    imports: [NgClass, AsyncPipe, TranslateModule, SensorValuePipe]
})

export class AddressCardComponent implements OnChanges {

  @Input() width: number;
  @Input() unitData: UnitAdditionalData;

  public sensorGpsSatellites: SensorLastValue;

  constructor(public viewBreakpointService: ViewBreakpointService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['unitData']) {
      this.sensorGpsSatellites = this.unitData.getSensorLastValueByName(SensorName.SATELLITES);
    }
  }
}
